// eslint-disable-next-line @github-ui/github-monorepo/filename-convention
export const COPY = {
  heading: {
    title: 'The AI assistant that builds with you',
    description: 'Generate code, manage tasks, and explore your projects all in one place with GitHub Copilot',
  },
  ideList: {
    title: 'Try Copilot on your favorite platform',
  },
} as const
